import { render, staticRenderFns } from "./CustomFieldsEditLayoutsModal.vue?vue&type=template&id=07c6ca9a&"
import script from "./CustomFieldsEditLayoutsModal.vue?vue&type=script&lang=js&"
export * from "./CustomFieldsEditLayoutsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports